import React from 'react'
import { Explanation, Course, Success, Navbar, CurrentNews, Banner,
  Footer, Main, Join, Faq, Study, TrialRecord, Information, Winter
} from './index';

import { BrowserRouter, Route } from 'react-router-dom';


class App extends React.Component {
  render() {
    // URL 宣言
    const url ='/yotsutaninet/';
    return (
      <div>
        <BrowserRouter>
          <Navbar />
          <Route path={url} exact component={CurrentNews} />
          <div style={{marginBottom:'70px'}}></div>
          <Route path={url}  exact component={Main} />
          <Route path={url + 'Explanation'} component={Explanation} />
          <Route path={url + 'Course'} component={Course} />
          <Route path={url + 'Winter'} component={Winter} />
          <Route path={url + 'Success'} component={Success} />
          <Route path={url + 'Join'} component={Join} />
          <Route path={url + 'Faq'} component={Faq} />
          <Route path={url + 'StudyFlow'} component={Study} />
          <Route path={url + 'TrialRecord'} component={TrialRecord} />
          <Route path={url + 'Information'} component={Information} />
          {/* <Route path="/" component={Banner} /> */}
          <Route path={url}  component={Footer} />

        </BrowserRouter>
      </div>
    );
  }
}
export default App;